module.exports = __webpack_public_path__ + "static/img/39.e8bbb294.png";